import client from "@/utils/client";

export const getPaymentStatus = async (
  paymentId: string,
  token?: string | null,
  currentPackage?: string | null
) => {
  return client.post(`/payment-status/${paymentId}`, {
    token,
    currentPackage,
  });
};
